import ImageWithFallback from '@/components/ImageWithFallback';
import useViewport from '@/hooks/useViewport';

export type ArtistListItemProps = {
  id: string;
  imageUrl: string;
  artistName: string;
};

const MobileArtistListItem = (props: ArtistListItemProps) => {
  const { artistName, imageUrl } = props;

  return (
    <div className={`flex w-full items-center gap-[16px]`}>
      <div
        className={`h-[80px] w-[80px] shrink-0 overflow-hidden rounded-full`}
      >
        <ImageWithFallback
          height={80}
          width={80}
          src={imageUrl}
          key={imageUrl}
          placeholder="blur"
          blurDataURL={imageUrl}
          alt={`${artistName} image`}
          className={`h-full w-full object-cover`}
        />
      </div>
      <p className={`font-roboto text-h5 font-normal`}>{artistName}</p>
    </div>
  );
};

const DesktopArtistListItem = (props: ArtistListItemProps) => {
  const { artistName, imageUrl } = props;

  return (
    <div className={`flex w-full items-center gap-[32px]`}>
      <div
        className={`h-[80px] w-[80px] shrink-0 overflow-hidden rounded-full`}
      >
        <ImageWithFallback
          width={80}
          height={80}
          src={imageUrl}
          key={imageUrl}
          placeholder="blur"
          blurDataURL={imageUrl}
          alt={`${artistName} image`}
          className={`h-full w-full object-cover`}
        />
      </div>
      <p className={`font-roboto text-h4 font-medium`}>{artistName}</p>
    </div>
  );
};

const ArtistListItem = (props: ArtistListItemProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile` || viewport == `tablet`) {
    return <MobileArtistListItem {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopArtistListItem {...props} />;
  }

  return null;
};

export default ArtistListItem;
